var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.isLockable
    ? _c(
        "v-col",
        {
          staticClass:
            "justify-space-between wrap d-inline-flex align-center pt-0",
          attrs: {
            cols: "12"
          }
        },
        [
          _c("v-switch", {
            on: {
              change: _vm.switchModalState
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function fn() {
                    return [
                      _c(
                        "div",
                        [
                          _vm._v(" Registrar Lock "),
                          _c(
                            "v-tooltip",
                            {
                              attrs: {
                                top: ""
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function fn(_ref) {
                                      var on = _ref.on
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            {
                                              staticClass: "mb-1",
                                              on: {
                                                click: function click($event) {
                                                  $event.stopPropagation()
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [_vm._v("mdi-information-outline")]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                801146295
                              )
                            },
                            [
                              _vm._v(
                                " Locking your domain prevents it from being transferred away "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1574802391
            ),
            model: {
              value: _vm.registrar_lock,
              callback: function callback($$v) {
                _vm.registrar_lock = $$v
              },
              expression: "registrar_lock"
            }
          }),
          _vm.allowEPP
            ? _c(
                "gg-btn",
                {
                  attrs: {
                    primary: "",
                    tile: "",
                    color: "primary",
                    loading: _vm.loading_epp
                  },
                  on: {
                    click: _vm.sendEPP
                  }
                },
                [_vm._v(" Send EPP / Transfer Code ")]
              )
            : _vm._e(),
          _c("gg-modal", {
            attrs: {
              "is-active": _vm.modal
            },
            on: {
              close: function close($event) {
                return _vm.switchModalState("cancel")
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "toolbar",
                  fn: function fn() {
                    return [_vm._v(" Registrar Lock ")]
                  },
                  proxy: true
                },
                {
                  key: "body",
                  fn: function fn() {
                    return [
                      _vm.registrar_lock
                        ? _c("div", {}, [
                            _vm._v(
                              " Locking your domain name will prevent your domain from being transferred to another provider and protect against accidental transfer."
                            ),
                            _c("br"),
                            _c("br"),
                            _vm._v("Are you sure you wish to continue? ")
                          ])
                        : _c("div", [
                            _vm._v(
                              " Unlocking your domain name will make it available to transfer to another provider. Leaving your domain name unlocked could lead to accidental transfer."
                            ),
                            _c("br"),
                            _c("br"),
                            _vm._v("Are you sure you wish to continue? ")
                          ])
                    ]
                  },
                  proxy: true
                },
                {
                  key: "actions",
                  fn: function fn() {
                    return [
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            secondary: ""
                          },
                          on: {
                            click: function click($event) {
                              return _vm.switchModalState("cancel")
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            primary: "",
                            loading: _vm.loading
                          },
                          on: {
                            click: _vm.setRegLock
                          }
                        },
                        [_vm._v("Save")]
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              4051381289
            )
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }